import './fileType-column-control.scss';
import React from 'react';
import {BaseCol} from './base-col';
import {FILE_TYPES} from '../../../../../icons/icons';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {DeepReadonly} from 'utility-types';
import {ProdDocument} from '../../../../search-types';
import {ResultItemViewConfig} from '../../../../../config/config-types';

export type FileTypeColumnControlProps = {
    doc: DeepReadonly<ProdDocument> | undefined;
    resultItemViewConfig: ResultItemViewConfig;
};

export const FileTypeColumnControl = ({doc, resultItemViewConfig}: FileTypeColumnControlProps): React.JSX.Element => {
    if (!doc) {
        return <></>;
    }

    const contentType = doc.metadata['contentTypeCategory_string'];

    if (!resultItemViewConfig.showFileTypeIcons || !contentType) {
        return <div className={'no-icon-filetype'}></div>;
    } else {
        return (
            <BaseCol className={'document-column-filetype colored-filetype-icon'}>
                {contentType === 'pdf' &&
                    <span>
                        <SvgIcon className={'pdf'} icon={FILE_TYPES.PDF}/>
                    </span>
                }
                {contentType === 'word' &&
                    <span>
                        <SvgIcon className={'word'} icon={FILE_TYPES.WORD}/>
                    </span>
                }
                {contentType === 'excel' &&
                    <span>
                        <SvgIcon className={'excel'} icon={FILE_TYPES.EXEL}/>
                    </span>
                }
                {contentType === 'powerpoint' &&
                    <span>
                        <SvgIcon className={'powerpoint'} icon={FILE_TYPES.POWERPOINT}/>
                    </span>
                }
                {contentType === 'image' &&
                    <span>
                        <SvgIcon className={'image'} icon={FILE_TYPES.IMAGE}/>
                    </span>
                }
                {contentType === 'webdocument' &&
                    <span>
                        <SvgIcon className={'code'} icon={FILE_TYPES.CODE}/>
                    </span>
                }
                {contentType === 'email' &&
                    <span>
                        <SvgIcon className={'email'} icon={FILE_TYPES.EMAIL}/>
                    </span>
                }
                {contentType === 'text' &&
                    <span>
                        <SvgIcon className={'txt'} icon={FILE_TYPES.TXT}/>
                    </span>
                }
                {contentType === 'other' &&
                    <span>
                        <SvgIcon className={'undefined'} icon={FILE_TYPES.UNDEFINED}/>
                    </span>
                }
            </BaseCol>
        );
    }
};
